var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from 'react';
import { initAuth } from '@js/common/auth/modalHandler';
import { fetchApi } from '@js/common/helpers';
import { HttpMethods } from 'tagwalk-api-client/assets/js/common/enums';
export function useNotifyMe(slug, userEmail, onSubscribeAccepted) {
    var _a = useState(false), subscribed = _a[0], setSubscribed = _a[1];
    var _b = useState(false), busy = _b[0], setBusy = _b[1];
    var _c = useState(false), failed = _c[0], setFailed = _c[1];
    var inFlight = useRef(false);
    var userActed = useRef(false);
    useEffect(function () {
        if (!userEmail) {
            return;
        }
        var cancelled = false;
        fetchApi('api_event_notify_me_status', HttpMethods.get, { slug: slug })
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (data) {
            if (cancelled || userActed.current || !data) {
                return;
            }
            setSubscribed(data.subscribed);
        });
        return function () {
            cancelled = true;
        };
    }, [slug, userEmail]);
    function getStatus() {
        if (busy) {
            return 'pending';
        }
        if (failed) {
            return 'error';
        }
        if (subscribed) {
            return 'done';
        }
        return 'idle';
    }
    function send(subscribe) {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, exception_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, 6, 7]);
                        if (!subscribe) return [3, 2];
                        return [4, fetchApi('api_event_notify_me', HttpMethods.post, { slug: slug }, {})];
                    case 1:
                        _a = _b.sent();
                        return [3, 4];
                    case 2: return [4, fetchApi('api_event_notify_me_cancel', HttpMethods.delete, { slug: slug })];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        response = _a;
                        if (!response.ok) {
                            setFailed(true);
                            return [2];
                        }
                        setSubscribed(subscribe);
                        return [3, 7];
                    case 5:
                        exception_1 = _b.sent();
                        setFailed(true);
                        return [3, 7];
                    case 6:
                        inFlight.current = false;
                        setBusy(false);
                        return [7];
                    case 7: return [2];
                }
            });
        });
    }
    function toggle() {
        if (inFlight.current || busy) {
            return;
        }
        if (!userEmail) {
            initAuth('calendar');
            return;
        }
        var subscribe = !subscribed;
        inFlight.current = true;
        userActed.current = true;
        setBusy(true);
        setFailed(false);
        if (subscribe && onSubscribeAccepted) {
            onSubscribeAccepted();
        }
        void send(subscribe);
    }
    return { status: getStatus(), subscribed: subscribed, toggle: toggle };
}
